// extracted by mini-css-extract-plugin
export var resizer = "_h5-0";